import React from 'react';
import { HeaderWrapper } from './Header.style';

export default () => (
  <HeaderWrapper>
    <h3>Sharjah Triennial Weather Maps</h3>
  </HeaderWrapper>
)



// WEBPACK FOOTER //
// ./src/components/Header/index.js